<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <organizations-request-accept-page /><br>
    </div>
  </div>
</template>

<script>
import OrganizationsRequestAcceptPage from '../Components/OrganizationsRequestAcceptPage.vue';
export default {
  name: 'OrganizationsRequestAccept',
  components: {
    'organizations-request-accept-page': OrganizationsRequestAcceptPage,
  },
};
</script>

<style scoped></style>
